import React, { useRef } from 'react';
import {
  Box,
  Container,
  makeStyles
} from '@material-ui/core';
import Page from 'src/components/Page';
import Results from './Results';
import Toolbar from '../common/Toolbar';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  }
}));

const FormationList = () => {
  const classes = useStyles();
  const resultRef = useRef();

  const onAdd = () => {
    resultRef.current.onAdd();
  };

  return (
    <Page
      className={classes.root}
      title="Formationen"
    >
      <Container maxWidth={false}>
        <Toolbar onAdd={onAdd} />
        <Box mt={3}>
          <Results
            ref={resultRef}
          />
        </Box>
      </Container>
    </Page>
  );
};

export default FormationList;
